
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/byd",
      function () {
        return require("private-next-pages/byd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/byd"])
      });
    }
  